import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import { SkyBetOddsLink } from '../SkyBetOddsLink';

export const TeamCard = ({
    teamName,
    badge,
    showSkybetLink,
    skybetLinkHref
}) => {
    return (
        <Styled.Wrapper>
            <Styled.CardWrapper>
                {badge && <Styled.Badge src={badge} alt={teamName} />}
                <Styled.TeamName>{teamName}</Styled.TeamName>
            </Styled.CardWrapper>
            {showSkybetLink && <SkyBetOddsLink href={skybetLinkHref} />}
        </Styled.Wrapper>
    );
};

TeamCard.defaultProps = {
    teamName: '-',
    badge: null,
    showSkybetLink: false,
    skybetLinkHref: 'https://skybet.com'
};

TeamCard.propTypes = {
    teamName: PropTypes.string,
    badge: PropTypes.string,
    showSkybetLink: PropTypes.bool,
    skybetLinkHref: PropTypes.string
};

export default TeamCard;
